import { QuestionTextType } from '@data/types';
import React from 'react';

interface Props extends QuestionTextType {}

const QuestionText: React.FC<Props> = ({ text }) => {
  return (
    <strong className="block text-1xl font-lightNormal leading-8 mb-6">
      {text}
    </strong>
  );
};

export default QuestionText;
